export const LINE = 'rgb(237, 238, 239)';
export const LINE_MID = 'rgb(215, 215, 215)';
export const CANVAS = 'rgb(242, 242, 242)';
export const LIVE_BG = 'rgb(206, 238, 227)';
export const LIVE_DOT = 'rgb(0, 168, 107)';

export const SETTINGS_WIDTH = 470;

/** Selected state: a 2px inset red ring, offset so it hugs the card. */
export const ring = (selected: boolean, offset = 0) => ({
  content: '""',
  position: 'absolute' as const,
  left: -offset,
  right: -offset,
  top: -offset,
  bottom: -offset,
  border: '2px solid',
  borderColor: 'primary.main',
  borderRadius: '8px',
  pointerEvents: 'none' as const,
  display: selected ? 'block' : 'none',
});

export const resetButton = {
  p: 0,
  m: 0,
  border: 'none',
  background: 'none',
  font: 'inherit',
  color: 'inherit',
  cursor: 'pointer',
  textAlign: 'left' as const,
};
